module.exports = __webpack_public_path__ + "img/1125007560.1d2f14be.jpg";